<template>
  <div class="tradesman-information">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.uuid"
                  clearable
                  filterable
                  placeholder="选择匠人">
            <Option v-for="item in trandList"
                    :value="item.uuid"
                    :key="item.uuid">{{item.nickname}}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.source"
                 clearable
                 placeholder="输入来源查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="dataInfo"
            ref="dataInfoValidate"
            :rules="dataInfoValidate"
            :label-width="80"
            action="javascript:void(0)">
        <FormItem label="选择匠人"
                  label-position="top"
                  prop="uuid"
                  style="width:300px">
          <Select v-model="dataInfo.uuid"
                  clearable
                  filterable
                  @on-query-change="SearchTrades"
                  placeholder="选择匠人">
            <Option v-for="item in trandList"
                    :value="item.uuid"
                    :key="item.uuid">{{item.nickname}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="名称"
                  prop="title">
          <Input v-model="dataInfo.title"
                 placeholder="输入名称..."></Input>
        </FormItem>
        <FormItem label="来源"
                  prop="source">
          <Input v-model="dataInfo.source"
                 placeholder="输入来源..."></Input>
        </FormItem>
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="dataInfo.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="232"
                        :autoCropHeight="164"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:232*164'"></upload-thumb>
        </FormItem>
        <FormItem label="内容"
                  prop="content">
          <UEditor v-model="dataInfo.content"
                   ref="editContent"></UEditor>
        </FormItem>
        <FormItem label="发布时间">
          <DatePicker v-model="dataInfo.time"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="发布时间"
                      style="width: 200px"
                      type="datetime"
                      @on-change="changeDateTwo"></DatePicker>
        </FormItem>
        <FormItem label="跳转地址"
                  prop="link_url">
          <Input v-model="dataInfo.link_url"
                 placeholder="输入跳转地址..."></Input>
        </FormItem>
        <FormItem label="选择头条推荐类型"
                  label-position="top"
                  v-show="dataInfo.id==''">
          <Select v-model="dataInfo.push_type"
                  clearable
                  filterable
                  placeholder="选择推荐类型">
            <Option v-for="item in pushtypelist"
                    :value="item.id"
                    :key="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="头条分类"
                  label-position="top"
                  v-show="dataInfo.id==''">
          <Select v-model="dataInfo.cate_id"
                  clearable
                  filterable
                  placeholder="选择头条分类">
            <Option v-for="item in catelist"
                    :value="item.f_id"
                    :key="item.f_id">{{item.f_name}}</Option>
          </Select>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false;step='firstStep'">取消</Button>
        <Button type="primary"
                @click="createInfo('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import UEditor from "../common/ueditor";

export default {
  name: "tradesman-information",
  data () {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      loading: true,
      dataloading: true,
      thumblist: [],
      pushtypelist: [],
      catelist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
        uuid: '',
      },
      bigDisplay: '',
      list: [
        {
          title: 'Id',
          key: 'id',
        },
        {
          title: '名称',
          key: 'title',
        },
        {
          title: '匠人名称',
          key: "tradesman_name"
        },
        {
          title: '来源',
          key: 'source',
        },
        {
          title: '发布时间',
          key: 'time',
        },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.status == 1 ? true : false  //控制开关的打开或关闭状态，官网文档属性是value
                },
                on: {
                  'on-change': (value) => {
                    this.changeStatus(params.row.id, value)
                  }
                }
              }, '开关')
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      trandList: [],
      tablelist: [],
      dataInfo: {
        title: '',
        link_url: "",
      },
      showModalStatus: false,
      dataInfoValidate: {
        title: [
          { required: true, message: '标题必须填写', trigger: 'blur' },
          { type: 'string', min: 2, max: 120, message: '文字 2 - 120 位长度', trigger: 'blur' }

        ],
      },
    }
  },
  created: function () {

    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb,
    UEditor
  },
  methods: {
    getTableList: function () {
      this.getTradList();
      this.$api.tradesmanInformation.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.count;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getTradList: function () {
      this.$api.tradesman.list({ page: 1, size: 10 }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    getPushTypeList: function () {
      this.$api.headlinepush
        .list({
          page: 1,
          size: 100
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.pushtypelist = res.result.list;
          }
        });
    },
    getCateList: function () {
      this.$api.headlinecate.list().then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.catelist = res.result;
          // console.log(res.result);
        }
      });
    },
    // 展开添加
    showModel () {
      this.getTradList();
      this.getPushTypeList();
      this.getCateList();
      this.title = "添加";
      this.dataInfo = {
        id: "",
        title: '',
        source: '',
        content: "",
        link_url: '',
      };
      this.thumblist = new Array();
      this.$refs["editContent"].message = "";
      this.$refs['dataInfoValidate'].resetFields();
      this.dataInfo.time = new Date();
      this.showModalStatus = !this.showModalStatus;
    },
    changeDateTwo (val) {
      this.dataInfo.time = val;
    },
    // 添加
    createInfo (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.dataInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.dataInfo.thumb = null;
          }
          this.dataInfo.content = this.$refs["editContent"].message;
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.tradesmanInformation.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });

            });
          } else {
            this.$api.tradesmanInformation.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });

            });
          }
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.tradesmanInformation.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 详情
    detail (index, id) {
      this.getTradList();
      this.title = "编辑";
      this.dataInfo = {
        id: "",
        title: '',
        source: '',
        link_url: '',
      };
      this.thumblist = new Array();
      this.$refs["editContent"].message = "";
      this.$refs['dataInfoValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
      this.$api.tradesmanInformation.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        this.$refs["editContent"].message = this.dataInfo.content;
        //处理thumb
        if (this.dataInfo.thumb != null && this.dataInfo.thumb != "") {
          this.thumblist.push({
            name: this.dataInfo.thumb,
            url: this.dataInfo.thumb,
            status: "finished"
          });
        }
      });
    },
    //搜索匠人
    SearchTrades: function (index) {
      this.$api.tradesman.list({ page: 1, size: 10, key: index }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.tradesmanInformation.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = { 'key': this.formItem.key, "page": this.pages.page, "size": this.pages.size, uuid: this.formItem.uuid, source: this.formItem.source };
      this.$api.tradesmanInformation.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
</script>

<style scoped>
</style>